@if (data(); as msg) {
 <span>Room {{msg.code}} already exists.</span>
}
 